import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo } from 'react';
import useLegacyProps from '../../hooks/useLegacyProps.js';

var _excluded = ["children"];
var _templateObject;
var StyledDiv = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & + & {\n    margin-top: 1rem;\n  }\n  &&& {\n    ", "\n  }\n"])), function (_ref) {
  var grid = _ref.theme.grid;
  return (grid === null || grid === void 0 ? void 0 : grid.gutterSize) && "margin-left: -".concat(grid.gutterSize, ";\n       margin-right: -").concat(grid.gutterSize, ";\n      ");
});
var Row = function Row(_ref2) {
  var children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  return /*#__PURE__*/React.createElement(StyledDiv, _extends({}, rest, {
    className: "row ".concat(className),
    style: style
  }), children);
};
var index = /*#__PURE__*/memo(Row);

export default index;
